import React from "react"
import PropTypes from "prop-types"
import AppShell from "../ui/AppShell/AppShell"

/**
 * Application layout.
 *
 * Delegates to the new `AppShell` (token-styled sidebar + header). The previous
 * implementation's parts — `Navigator`, `Navbar`, `Drawer`, `Footer` and
 * `styles/layout.scss` — are still in the repo, so reverting is a matter of
 * restoring this file from git if the new chrome causes trouble on a screen
 * that hasn't been migrated yet.
 */
const LayoutWrapper = ({ children }) => <AppShell>{children}</AppShell>

LayoutWrapper.propTypes = {
  children: PropTypes.node
}

export default LayoutWrapper
